<template>
  <div v-if="show" id="demonstration">
    <div class="mask" @click="close"></div>
    <div class="model">
            <!-- 登录窗口 -->
      <div v-if="!isLogin" class="h_banner_login">
        <div class="h_banner_login_title font-24 fontweight-bo color">
          账号登录
        </div>
        <div class="h_banner_login_li_toubu" >
          <img v-if="this.$parent.isorder" class="h_banner_login_li_toubu"  src="@/assets/icon/toubu.png" />
        </div>
        <!-- 账号 -->
        <div class="h_banner_login_line">
          <div class="h_banner_login_border">
            <img
              class="h_banner_login_li_icon"
              src="@/assets/icon/login_username.png"
            />
          </div>
          <input
            class="h_banner_login_li_input"
            data-type="username"
            placeholder="会员号/手机号"
            v-model="minilogin['username']"
            @blur="miniloginChange"
            @keyup.enter="func_login"
          />
        </div>
        <!-- 密码 -->
        <div class="h_banner_login_line">
          <div class="h_banner_login_border">
            <img
              class="h_banner_login_li_icon"
              src="@/assets/icon/login_password.png"
            />
          </div>
          <input
            class="h_banner_login_li_input"
            data-type="password"
            placeholder="密码"
            type="password"
            v-model="minilogin['password']"
            @blur="miniloginChange"
            @keyup.enter="func_login"
          />
        </div>
        <div
          class="
            h_banner_login_submit
            
            fontweight-bo
            no-copy
          "
          @click="func_login"
        >
          <!-- 正常状态 -->
          <div v-if="!minilogin.isIng" class="h_banner_login_sub_normal">
            登录
          </div>
          <!-- 登录中状态 -->
          <img
            v-if="minilogin.isIng"
            class="h_banner_login_sub_icon"
            src="@/assets/icon/login_ing.png"
          />
          <div v-if="minilogin.isIng" class="h_banner_login_sub_ing font-14">
            登录中....
          </div>
        </div>
        <div v-if="this.$parent.isorder" class="xincaihang">广东新彩航印刷有限公司</div>
        <div class="h_banner_login_btn">
          <div
            class="
              h_banner_login_btn_view
              font-12
              color-prompt-then
              font-hover
              no-copy
            "
            data-opera="register"
            v-if="this.$parent.isorder"
            @click="func_loginPlate"
          >
            新用户注册
          </div>
          <div
            class="
              h_banner_login_btn_view
              font-12
              color-prompt-then
              font-hover
              no-copy
            "
            data-opera="Retrieve"
            @click="func_loginPlate"
            v-if="this.$parent.isorder"
          >
            忘记密码？
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { req_userLogin } from "@/services/user";
export default {
  data() {
    return {
      mov1: "",
      show: false,
      disabled: false, //是否禁用
      width: 0,
      minilogin: {
        username: "",
        password: "",
        isIng: false, //点击状态
      },
      isLogin: false, //是否已登录
      userinfo: {},
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
        // 登录内容输入
    miniloginChange(event) {
      const type = event.currentTarget.dataset.type;
      const value = event.target.value;
      this.minilogin[type] = value;
    },
    // 提交登录
    func_login() {
      if (this.minilogin["isIng"]) return;
      this.minilogin["isIng"] = true;
      setTimeout(async () => {
        if (
          this.minilogin["username"].toString().length < 1 ||
          this.minilogin["password"].toString().length < 1
        ) {
          this.$parent.$parent.msgChange("fail", "会员号/手机号不能为空!", "", 3000);
          this.minilogin["isIng"] = false;
          return;
        }
        const result = await req_userLogin(
          this.minilogin["username"],
          this.minilogin["password"]
        );
        this.minilogin["isIng"] = false;
        if (result.success) {
          // 判断用户 !isok||isok=0 用户审核未通过
          if (!result.data["isok"] || result.data["isok"].toString() === "0") {
            this.$parent.$parent.confirmChange(
              "warning",
              "账号审核未通过！请联系客服QQ开通",
              () => {},
              () => {},
              { yes: "知道了", no: "" }
            );
          } else {
            this.$parent.$parent.msgChange("success", "登录成功", "", 3000);
            // 1) 调用全局登录流程
            this.$parent.$parent.func_appLogin(result.data);
            // 2) 通知本页已登录
            
            this.$parent.userinfo = result.data
            this.$parent.isLogin = true
            this.$parent.func_shuaxin()
            this.close()
          }
        } else {
          this.$parent.$parent.msgChange("fail", result.msg, "", 3000);
        }
      }, 500);
    },
  },
};
</script>
<style src='@/style/demonstration.css' scoped></style>




// WEBPACK FOOTER //
// src/components/fileUpload/demonstration.vue